import styled from '@emotion/styled';
import {
	Css,
	ITheme,
	Responsive,
	Shimmer,
	ShimmerPlaceholderText,
} from '../../../ui';
import {
	InfoCard,
	InfoCardDivider,
	InfoCardIcons,
	InfoCardTitleSection,
	InfoCardTop,
} from '../../../components/common/cards/InfoCard/InfoCard.styles';

export default function ParkingCardsShimmer() {
	return (
		<StyledShimmer>
			{[...Array(6)].map((_, index) => (
				<StyledInfoCard
					key={index} /* eslint-disable-line react/no-array-index-key */
				>
					<InfoCardTop>
						<TopSection>
							<InfoCardTitleSection>
								<StyledShimmerTitle />
							</InfoCardTitleSection>
							<div>
								<StyledParkingPriceShimmerDescription />
							</div>
						</TopSection>
						<TopSectionRight>
							<InfoCardIcons>
								<StyledShimmerIcons />
							</InfoCardIcons>

							<StyledShimmerRemark />
						</TopSectionRight>
					</InfoCardTop>

					<InfoCardDivider />

					<hr />
					<StyledShimmerBottomLeft />
				</StyledInfoCard>
			))}
		</StyledShimmer>
	);
}

const StyledShimmer = styled(Shimmer)<{}, ITheme>`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${(props) => props.theme.grid.gutter.horizontal.default};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		flex-direction: column;
	}
`;

const StyledInfoCard = styled(InfoCard)`
	padding: ${Css.pxToRem(14)} ${Css.pxToRem(16)};
`;

const StyledShimmerTitle = styled(ShimmerPlaceholderText)`
	width: 170px;
	height: 24px;
`;

export const StyledParkingPriceShimmerDescription = styled(
	ShimmerPlaceholderText,
)`
	width: 50px;
	height: 22px;
`;

const StyledShimmerIcons = styled(ShimmerPlaceholderText)`
	width: 73px;
	height: 24px;
`;

const StyledShimmerRemark = styled(ShimmerPlaceholderText)`
	width: 46px;
	height: 22px;
`;

const TopSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(4)};
`;

const TopSectionRight = styled(TopSection)`
	align-items: flex-end;
`;

const StyledShimmerBottomLeft = styled(ShimmerPlaceholderText)`
	width: 90px;
	height: 24px;
`;
